import "../css/App.css";
import Cube from "./Cube";

function App() {
    return (
        <div className="App">
            <Cube />
        </div>
    );
}

export default App;
